module.exports = __webpack_public_path__ + "bf51155658fdfac10c53a7569c1b2679.jpg";